// extracted by mini-css-extract-plugin
export default {"container":"cn5Ml64V4WWS05IuF7W1","promoIdentifier":"FsVYPlfvN99XHTdpCs_j","clickableWrapper":"wxMCRXdrfv0pxKgWNX4i"};